module.exports = __webpack_public_path__ + "media/images/badge-order-943c5ec559b91b5c1617f559fc6addcc.svg";